const CAMERA_TYPES = {
  BOSH_FIXED: 'BOSH_FIXED',
  BOSH_ENCODER: 'BOSH_ENCODER',
  HIKVISION_DVR: 'HIKVISION_DVR',
  DAHUA_DVR_NVR: 'DAHUA_DVR_NVR',
};

export default CAMERA_TYPES;
